import { t } from 'ttag';

/** 0–1 playback fraction → 0–100 for aria-valuenow. */
export const progressPercent = (progress?: number) =>
  Math.round(Math.min(1, Math.max(0, Number(progress) || 0)) * 100);

/**
 * Task-96 / Level Access: expose the play-button ring like course ProgressBar
 * (role=progressbar + valuemin/max/now/text). Idle (0%) stays aria-hidden.
 */
export const mediaProgressAria = (percent: number) =>
  percent > 0
    ? {
        role: 'progressbar' as const,
        'aria-label': t`Media progress`,
        'aria-valuemin': 0,
        'aria-valuemax': 100,
        'aria-valuenow': percent,
        'aria-valuetext': `${percent}% ${t`played`}`
      }
    : { 'aria-hidden': true as const };
